<template>
  <div class="audit-card mb-3">
    <div class="inner">
      <!--      <b class="audit-name">{{ audit.user ? audit.user.name : 'Unknown user' }}</b> <br>-->
      <b class="audit-name">
        {{ formatDateCustomFormat(audit.created_at, 'Do MMM YYYY, HH:mm') }}
      </b> <br>
      <div class="mt-1 change-details">
        {{ audit.user ? audit.user.name : 'Unknown user' }} updated
        <span v-html="humanChanges"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Dates from "../../../../../../mixins/Dates";
import Tickets from "../../../../../../mixins/Tickets";
import {mapGetters} from "vuex";

export default {
  name: "Audit",
  props: ['audit'],
  mixins: [Dates, Tickets],
  methods: {
    getHumanProperty(property) {
      switch (property) {
        case 'agent_id':
          return 'agent';
        default:
          return property;
      }
    },

    getHumanValue(property, value) {
      switch (property) {
        case 'status':
          return this.getHumanReadableTicketStatus(value);
        case 'priority':
          return this.getHumanReadableTicketPriority(value);
        case 'difficulty':
          return this.getHumanReadableTicketDifficulty(value);
        case 'agent_id':
          let agent = _.find(this.agents, {id: value});
          return agent ? agent.name : 'unknown';
        default:
          return value;
      }
    }
  },
  computed: {
    ...mapGetters('ticketViewer', {
      agents: 'agents'
    }),

    humanChanges() {
      let changes = [];

      _.each(this.audit.old_values, (value, index) => {
        let change = this.getHumanProperty(index) + ' from <i>' + this.getHumanValue(index, value) + '</i> to <i>' + this.getHumanValue(index, this.audit.new_values[index]) + '</i>';
        changes.push(change);
      });

      return changes.join(' and ');
    }
  }
}
</script>

<style scoped lang="scss">
.audit-card {
  background: #fff;
  border-radius: 5px;

  .audit-name {
    font-weight: 600;
    color: #2c5cc5;
  }

  .inner {
    //padding-left: 15px;
    //padding-right: 15px;
    padding: 10px;
  }

  .change-details {
    font-size: 12px;
    line-height: 19px;
  }
}
</style>